import { css } from '@bts-web/utils-style-engine';
import {
  ButtonBase,
  DocumentationExternalLink,
} from '@bts-web/core-features/common';
import {
  titleStyles,
  paragraphStyles,
  linkStyles,
  CommonConsentScreenProps,
} from '../CookiesConsentBanner/CookiesConsentBanner';
import { links } from '@bts-web/core-app-config';

interface MainConsentProps extends CommonConsentScreenProps {
  onClickManage: () => void;
}

const MainConsent = ({
  translations,
  updateCookiePreferences,
  onClickManage,
  language,
}: MainConsentProps) => {
  const handleAcceptAll = () => {
    updateCookiePreferences({
      performance: true,
      marketing: true,
    });
  };

  const handleAcceptEssentials = () => {
    updateCookiePreferences({
      performance: false,
      marketing: false,
    });
  };

  return (
    <>
      <div
        className={css({
          display: 'flex',
          flexDirection: 'column',
          gap: 'small',
        })}
      >
        <h2 className={titleStyles}>{translations.cookiesConsentTitle}</h2>
        <p
          className={`${paragraphStyles} ${
            language === 'ar'
              ? css({
                  fontSize: 'title.large',
                  fontFamily: 'title.large',
                  fontWeight: 'title.large',
                  lineHeight: 'title.large',
                  letterSpacing: 'title.large',
                })
              : ''
          }`}
        >
          {translations.cookiesConsentDescription}{' '}
          {translations.cookiePolicyLearnMore}{' '}
          <DocumentationExternalLink
            className={linkStyles}
            href={links.cookiePolicy}
            label={translations.cookiePolicy}
            visual="primaryUnderline"
            size="small"
          />
          .
        </p>
      </div>

      <div
        className={css({
          display: 'flex',
          flexDirection: 'column',
          gap: 'small',
        })}
      >
        <div
          className={css({
            display: 'flex',
            justifyContent: 'space-between',
            gap: 'small',
            '& > button': {
              flexShrink: 1,
            },
          })}
        >
          <ButtonBase fullWidth visual="primary" onClick={handleAcceptAll}>
            {translations.cookiesConsentAcceptAll}
          </ButtonBase>

          <ButtonBase
            fullWidth
            visual="primary"
            onClick={handleAcceptEssentials}
          >
            {translations.cookiesConsentAcceptEssentials}
          </ButtonBase>
        </div>

        <ButtonBase fullWidth visual="secondary" onClick={onClickManage}>
          {translations.cookiesConsentManage}
        </ButtonBase>
      </div>
    </>
  );
};

export { MainConsent };
